export default [
  {
    path: '/relVendasPorCliente/',
    name: 'relVendasPorCliente',
    title: 'relVendasPorCliente',
    component: () => import('../views/RelVendasPorClienteView.vue'),
    redirect: { name: 'relVendasPorCliente-listar' },
    children: [
      {
        path: 'welcome',
        name: 'relVendasPorCliente-listar',
        component: () => import('../views/RelVendasPorClienteWelcomeView.vue'),
        meta: {
          title: 'Relatório de vendas por cliente',
        },
      },
    ],
  },
];
